import { PAGE_SEO, BREADCRUMBS, BREADCRUMB_ITEMS } from "../data.js";
import Breadcrumb from "../components/Breadcrumb.jsx";
import { useState, useRef } from "react";
import { useAnim, useSEO } from "../hooks.jsx";
import { Ic } from "../icons.jsx";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../config/firebase";

// Audit 2026-09-20, punto #7: l'invio non passa più da EmailJS lato client
// (Service ID/Template ID/Public Key in chiaro nel bundle, nessun freno agli
// abusi) ma da una Cloud Function (submitContactForm) con App Check, rate
// limit per IP e honeypot — vedi functions/index.js.
const submitContactFormFn = httpsCallable(functions, "submitContactForm");

const WHY_ITEMS = [
  { i:"zap",   t:"Setup in 5 minuti",              d:"Configuri la piattaforma e sei online. Nessun tecnico necessario." },
  { i:"globe", t:"Sito incluso e personalizzabile", d:"Il tuo brand, i tuoi prezzi, i tuoi testi. Tutto dal pannello impostazioni." },
  { i:"lock",  t:"Sicuro e affidabile",             d:"Dati su Firebase Google, pagamenti Stripe PCI DSS. Infrastruttura enterprise." },
  { i:"bell",  t:"14 giorni gratis, senza impegno", d:"Provi la piattaforma con le funzionalità principali incluse. Nessuna carta di credito richiesta." },
];

export default function Contatti() {
  useAnim();
  useSEO({ ...PAGE_SEO.contatti, schema: BREADCRUMBS.contatti });

  const [form, setForm]       = useState({ nome:"", cognome:"", email:"", azienda:"", piano:"domanda", msg:"" });
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");
  // Honeypot: un utente umano non lo vede né lo compila mai (nascosto via CSS,
  // fuori dal flusso di tab); un bot che compila ogni campo del form sì.
  const honeypotRef = useRef(null);

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await submitContactFormFn({
        nome: form.nome,
        cognome: form.cognome,
        email: form.email,
        azienda: form.azienda,
        piano: form.piano,
        msg: form.msg,
        website: honeypotRef.current?.value || "",
      });
      setSent(true);
    } catch (err) {
      console.error("submitContactForm error:", err);
      const rateLimited = err?.code === "functions/resource-exhausted" || err?.code === "resource-exhausted";
      setError(rateLimited
        ? "Troppe richieste da questa connessione. Riprova tra qualche minuto o scrivici su WhatsApp."
        : "Errore durante l'invio. Riprova o contattaci via WhatsApp.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb items={BREADCRUMB_ITEMS.contatti} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Contatti</div>
          <h1 className="h2" style={{ fontSize:"clamp(1.9rem,4vw,2.9rem)" }}>
            Contatta NoleggioinCloud,<br /><mark>inizia gratis oggi</mark>
          </h1>
          <p className="lead" style={{ marginTop:".65rem" }}>
            Hai domande o vuoi una demo? Scrivici, ti risponderemo entro 24 ore lavorative.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background:"var(--bg)" }}>
        <div className="wrap">

          {/* ── BANNER TELEFONO ── */}
          <div className="an" style={{
            background:"var(--blue)",
            borderRadius:"var(--rl)",
            padding:"2rem 2.5rem",
            display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap",
            gap:"1.5rem",
            boxShadow:"0 8px 32px rgba(37,99,235,.22)",
            marginBottom:"3rem",
          }}>
            <div>
              <div style={{ color:"rgba(255,255,255,.7)", fontSize:".75rem", fontWeight:700, letterSpacing:".12em", textTransform:"uppercase", marginBottom:".35rem" }}>
                Scrivici su WhatsApp
              </div>
              <div style={{ color:"#fff", fontSize:"clamp(2rem,5vw,2.85rem)", fontWeight:900, letterSpacing:"-.02em", lineHeight:1 }}>
                +39 3892176062
              </div>
              <div style={{ color:"rgba(255,255,255,.65)", fontSize:".84rem", marginTop:".45rem" }}>
                Disponibili su WhatsApp · 10:00–14:00 e 16:00–19:00
              </div>
            </div>
            <div style={{ display:"flex", gap:".75rem", flexWrap:"wrap" }}>
              <a href="https://wa.me/393892176062?text=Ciao%2C%20vorrei%20informazioni%20su%20NoleggioinCloud" target="_blank" rel="noopener noreferrer" style={{ textDecoration:"none" }}>
                <div style={{
                  display:"flex", alignItems:"center", gap:".6rem",
                  background:"#25D366", color:"#fff",
                  borderRadius:"100px", padding:".7rem 1.6rem",
                  fontWeight:700, fontSize:".92rem", cursor:"pointer", transition:"opacity .2s",
                }}
                  onMouseEnter={e => e.currentTarget.style.opacity=".88"}
                  onMouseLeave={e => e.currentTarget.style.opacity="1"}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Scrivi su WhatsApp
                </div>
              </a>
            </div>
          </div>

          <div className="cg">

            {/* Why column */}
            <div className="an">
              <h2 className="h2" style={{ fontSize:"1.55rem", marginBottom:"1.6rem" }}>
                Perché scegliere<br /><mark>NoleggioinCloud</mark>
              </h2>
              {WHY_ITEMS.map(r => (
                <div className="cii" key={r.t}>
                  <div className="cico"><Ic n={r.i} s={20} /></div>
                  <div>
                    <div className="j" style={{ fontWeight:700, fontSize:".92rem", color:"var(--ink)", marginBottom:".2rem" }}>{r.t}</div>
                    <div style={{ fontSize:".85rem", color:"var(--muted)", lineHeight:1.65 }}>{r.d}</div>
                  </div>
                </div>
              ))}

              {/* Phone / WhatsApp */}
              <div style={{ marginTop:"1.5rem", padding:"1.35rem 1.5rem", background:"#fff", border:"1.5px solid var(--border)", borderRadius:"var(--r)" }}>
                <div className="j" style={{ fontWeight:700, fontSize:".78rem", color:"var(--muted)", letterSpacing:".1em", textTransform:"uppercase", marginBottom:".85rem" }}>
                  Contattaci direttamente
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:".75rem" }}>
                  <a href="https://wa.me/393892176062?text=Ciao%2C%20vorrei%20informazioni%20su%20NoleggioinCloud" target="_blank" rel="noopener noreferrer" style={{ display:"flex", alignItems:"center", gap:".85rem", textDecoration:"none" }}>
                    <span style={{ width:"2.2rem", height:"2.2rem", flexShrink:0, background:"var(--green-lt)", borderRadius:"9px", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="var(--green)"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                    </span>
                    <div>
                      <div style={{ fontSize:".92rem", fontWeight:700, color:"var(--ink)" }}>+39 3892176062</div>
                      <div style={{ fontSize:".76rem", color:"var(--muted)" }}>Solo WhatsApp</div>
                    </div>
                  </a>
                  <div style={{ display:"flex", alignItems:"center", gap:".85rem" }}>
                    <span style={{ width:"2.2rem", height:"2.2rem", flexShrink:0, background:"var(--blue-xl)", borderRadius:"9px", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      <Ic n="clock" s={15} />
                    </span>
                    <div>
                      <div style={{ fontSize:".92rem", fontWeight:700, color:"var(--ink)" }}>10:00–14:00 · 16:00–19:00</div>
                      <div style={{ fontSize:".76rem", color:"var(--muted)" }}>Orario WhatsApp</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Form column */}
            <div className="fcard an d2">
              {sent ? (
                <div style={{ textAlign:"center", padding:"2.5rem 0" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginBottom:"1rem"}}><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>
                  <h3 className="j" style={{ fontSize:"1.35rem", fontWeight:800, color:"var(--ink)", marginBottom:".5rem" }}>
                    Messaggio inviato!
                  </h3>
                  <p style={{ color:"var(--muted)" }}>Ti risponderemo entro 24 ore lavorative.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <h3 className="j" style={{ fontSize:"1.1rem", fontWeight:800, color:"var(--ink)", marginBottom:"1.5rem" }}>
                    Richiedi informazioni o demo
                  </h3>

                  {/* Honeypot anti-bot (audit 2026-09-20, punto #7): invisibile e
                      irraggiungibile da tastiera per un utente umano, ma
                      presente nel DOM e nel markup — i bot che compilano ogni
                      campo del form lo riempiono, tradendosi. */}
                  <div aria-hidden="true" style={{ position:"absolute", left:"-9999px", width:"1px", height:"1px", overflow:"hidden" }}>
                    <label htmlFor="c-website">Non compilare questo campo</label>
                    <input id="c-website" ref={honeypotRef} type="text" tabIndex={-1} autoComplete="off" />
                  </div>

                  <div className="name-row">
                    <div className="fg2">
                      <label className="fl" htmlFor="c-nome">Nome *</label>
                      <input id="c-nome" className="fo" placeholder="Mario" value={form.nome} onChange={set("nome")} required />
                    </div>
                    <div className="fg2">
                      <label className="fl" htmlFor="c-cog">Cognome</label>
                      <input id="c-cog" className="fo" placeholder="Rossi" value={form.cognome} onChange={set("cognome")} />
                    </div>
                  </div>

                  <div className="fg2">
                    <label className="fl" htmlFor="c-email">Email *</label>
                    <input id="c-email" className="fo" type="email" placeholder="mario@tuonoleggio.it" value={form.email} onChange={set("email")} required />
                  </div>

                  <div className="fg2">
                    <label className="fl" htmlFor="c-az">Nome attività</label>
                    <input id="c-az" className="fo" placeholder="Rossi Autonoleggio" value={form.azienda} onChange={set("azienda")} />
                  </div>

                  <div className="fg2">
                    <label className="fl" htmlFor="c-piano">Motivo del contatto / Piano</label>
                    <select id="c-piano" className="fo" value={form.piano} onChange={set("piano")}>
                      <option value="domanda">Ho una domanda generica / Altro</option>
                      <option value="trial">Voglio iniziare la prova gratuita (14 giorni)</option>
                      <option value="base">Piano Base — €34,99/mese (fino a 10 veicoli)</option>
                      <option value="pro">Piano Pro — €89,99/mese (senza dominio/hosting)</option>
                      <option value="biz">Business Pro — €169/mese (dominio + hosting inclusi)</option>
                    </select>
                  </div>

                  <div className="fg2">
                    <label className="fl" htmlFor="c-msg">Messaggio</label>
                    <textarea id="c-msg" className="fo" placeholder="Ho un noleggio con 20 veicoli e cerco una soluzione per…" value={form.msg} onChange={set("msg")} rows={3} />
                  </div>

                  {/* Messaggio di errore */}
                  {error && (
                    <div style={{
                      background:"#FEF2F2", border:"1.5px solid #FECACA",
                      borderRadius:"var(--r)", padding:".75rem 1rem",
                      fontSize:".83rem", color:"#B91C1C", marginBottom:".75rem",
                    }}>
                      {error}
                    </div>
                  )}

                  <button
                    type="submit"
                    className="btn btn-p btn-lg"
                    disabled={loading}
                    style={{ width:"100%", justifyContent:"center", marginTop:".5rem", opacity: loading ? .7 : 1, cursor: loading ? "not-allowed" : "pointer" }}
                  >
                    {loading ? "Invio in corso…" : "Invia richiesta →"}
                  </button>
                  <p style={{ fontSize:".73rem", color:"var(--muted)", textAlign:"center", marginTop:".7rem" }}>
                    Risposta garantita entro 24 ore lavorative
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
